/* Shopify injects correct CDN URL directly here */
const CELL_LIBRARY_URL = "//zeropointenergylabs.com/cdn/shop/t/7/assets/cell_library.json?v=184209128929832677261764086001";

let CELL_LIBRARY = {};

async function loadCells() {
    try {
        console.log("Loading cells from:", CELL_LIBRARY_URL);

        const response = await fetch(CELL_LIBRARY_URL);

        if (!response.ok) {
            console.error("JSON load failed:", response.status, CELL_LIBRARY_URL);
            return;
        }

        CELL_LIBRARY = await response.json();

        const selector = document.getElementById("cellSelector");
        if (!selector) {
            console.error("Dropdown element #cellSelector not found.");
            return;
        }

        selector.innerHTML = "";

        Object.keys(CELL_LIBRARY).forEach(cellName => {
            const opt = document.createElement("option");
            opt.value = cellName;
            opt.textContent = cellName;
            selector.appendChild(opt);
        });

    } catch (error) {
        console.error("Error loading cells:", error);
    }
}


/* Calculator Logic */
function calculatePack() {
    const cellName = document.getElementById("cellSelector").value;
    const series = parseInt(document.getElementById("seriesInput").value);
    const parallel = parseInt(document.getElementById("parallelInput").value);

    if (!cellName || !series || !parallel) {
        alert("Enter valid series/parallel values.");
        return;
    }

    const c = CELL_LIBRARY[cellName];
    const Vmax = c.max_voltage * series;
    const Vnom = c.nom_voltage * series;
    const Ah = c.capacity * parallel;
    const Imax = c.I_discharge * parallel;
    const weight = c.weight * series * parallel;

    const L = c.dimensions[0] * series;
    const W = c.dimensions[1] * parallel;
    const T = c.dimensions[2];

    /*const Wh_per_kg = (Ah * V) / (weight / 1000);*/
    /*const heat = (R / 1000) * (Imax ** 2);*/

    document.getElementById("results").innerHTML = `
        <p><strong>Total Maximum Voltage:</strong> ${Vmax.toFixed(2)} V</p>
        <p><strong>Total Nominal Voltage:</strong> ${Vnom.toFixed(2)} V</p>
        <p><strong>Total Capacity:</strong> ${Ah.toFixed(2)} Ah</p>
        <p><strong>Max Continuous Discharge:</strong> ${Imax.toFixed(2)} A</p>
        <p><strong>Total Weight:</strong> ${weight.toFixed(2)} g</p>
        <p><strong>Dimensions (L × W × T):</strong> ${L.toFixed(2)} × ${W.toFixed(2)} × ${T.toFixed(2)} mm</p>

    `;
}

document.addEventListener("DOMContentLoaded", loadCells);